import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface TemplateTextTypeModel {
  id?: number;
  name?: string;
}

class GetDefaultTemplateTextTypesRequest {}

class GetDefaultTemplateTextTypesResponse {
  defaultTemplateTextTypes?: TemplateTextTypeModel[];
}

class UpdateDefaultTemplateTextTypeRequest {
  name?: string;
  defaultTemplateTextTypeModel?: TemplateTextTypeModel;
}

class CreateDefaultTemplateTextTypeRequest {
  defaultTemplateTextTypeModel?: TemplateTextTypeModel;
}

class DeleteDefaultTemplateTextTypeRequest {
  defaultTemplateTextTypeName?: string;
}

export const templateTextTypeApi = {
  async getTemplateTextTypes(): Promise<Result<TemplateTextTypeModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetDefaultTemplateTextTypesResponse>(
        "GetDefaultTemplateTextTypes",
        new GetDefaultTemplateTextTypesRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.defaultTemplateTextTypes ?? [] };
    }

    return response;
  },

  async updateTemplateTextType(
    templateTextType: TemplateTextTypeModel,
    name?: string,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateDefaultTemplateTextType", {
      name: name,
      defaultTemplateTextTypeModel: templateTextType,
    } as UpdateDefaultTemplateTextTypeRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "DefaultTemplateTextTypeModel");

    return response;
  },

  async createTemplateTextType(
    templateTextType: TemplateTextTypeModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateDefaultTemplateTextType", {
      defaultTemplateTextTypeModel: templateTextType,
    } as CreateDefaultTemplateTextTypeRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "DefaultTemplateTextTypeModel");

    return response;
  },

  async deleteTemplateTextType(
    defaultTemplateTextTypeName?: string,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteDefaultTemplateTextType", {
      defaultTemplateTextTypeName: defaultTemplateTextTypeName,
    } as DeleteDefaultTemplateTextTypeRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },
};
